<template>
  <v-data-table
    :headers="headers"
    :items="items"
    sort-desc
    calculate-widths
    fixed-header
    class="settings-dt mail-dt"
    hide-default-footer
    height="calc(100vh - 48px)"
    :loading="loading"
    :footer-props="{'items-per-page-options': [-1]}"
    :items-per-page="-1"
  >

    <template v-slot:top>
      <update-form v-model="dialog" :item="item" :initItem="initItem" :refresh="load" />

      <v-dialog
        v-model="listSettingDialog"
        max-width="1200"
      >
        <v-card>
          <v-card-title>
            Configure List Filter
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="listStatuses"
                  label="Entity status"
                  hint="Select entity status to show mail templates from, empty filter shows all"
                  :items="listStatusOptions"
                  persistent-hint
                  multiple
                  clearable
                />
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions class="justify-end">
            <v-btn
              color="primary"
              @click="listSettingDialog = false, load()"
            >
              Confirm
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

    <template v-slot:header.action="{ item }">
      <div style="width: 84px" class="float-right">
        <v-btn
          icon
          @click="listSettingDialog = true"
        >
          <v-icon>
            mdi-tune
          </v-icon>
        </v-btn>
        <v-icon @click="load()">mdi-refresh</v-icon>
        <v-icon @click="edit(newItem)">mdi-plus</v-icon>
      </div>
    </template>

    <template v-slot:item.action="{ item }">
      <div style="width: 25px" class="float-right">
        <v-icon small @click="edit(item)">mdi-cog-outline</v-icon>
      </div>
    </template>

    <template v-slot:item.row_num="{ item }">
      <span class="row_num"></span>
    </template>
  </v-data-table>
</template>

<style>

  .mail-dt.v-data-table td,
  .mail-dt.v-data-table th {
    padding: 0 8px !important;
  }

  .mail-dt.v-data-table td {
    height: 32px !important;
  }

  .settings-dt tr:not(.report-filter-row) {
    counter-increment: row-num;
  }

  .settings-dt tr td:first-child .row_num::before {
    content: counter(row-num) ". ";
  }

</style>

<script>
  import { cloneDeep } from 'lodash'
  import { API } from '@/utils/api'

  export default {

    components: {
      UpdateForm: () => import('@/components/settings/mail/UpdateForm'),
    },

    data: () => ({
      newItem: {
        settings: {}
      },
      dialog: false,
      item: {
        settings: {}
      },
      initItem: {
        settings: {}
      },
      loading: false,
      headers: [
        { text: '#', value: 'row_num', sortable: false },
        { text: 'Project', value: 'project' },
        { text: 'From', value: 'settings.from' },
        { text: 'Email', value: 'settings.email' },
        { text: '', value: 'action', sortable: false },
      ],
      items: [],
      listSettingDialog: false,
      listStatuses: ['active'],
      listStatusOptions: ['active', 'blocked', 'hidden', 'report'],
    }),

    mounted () {
      this.load()
    },

    methods: {
      edit (item) {
        this.dialog = true
        this.initItem = cloneDeep(item)
        this.item = cloneDeep(item)
      },

      load () {
        this.loading = true
        return API.call('/mail/settings/list.json', {
          statuses: this.listStatuses,
        }).then(resp => {
          this.items = resp.data
        }).finally(() => {
          this.loading = false
        })
      },
    },

  }
</script>

